module.exports = __webpack_public_path__ + "media/images/riders/small/SAMUEL_GAZE-5a825bc4b330b15246c5ed8699b8ecc6.png";